module.exports = __webpack_public_path__ + "img/bg-d.a5b680f7.png";